'use client';

import { useSearchParams } from 'next/navigation';

export default function DynamicHeading({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const searchParams = useSearchParams();

  const searchParamHeading = searchParams?.get('headline');

  return <h1 className={className}>{searchParamHeading || children}</h1>;
}
